'use client';

import { Box, Container, Grid, Typography } from '@mui/material';

import { WhyChooseUs } from '../../../services/types';
import { getImageUrl } from '../../../services/utils';

interface WhyChooseUsSectionProps {
  data?: WhyChooseUs;
}

export default function WhyChooseUsSection({ data }: WhyChooseUsSectionProps) {
  if (!data) {
    return null;
  }

  return (
    <Box
      component='section'
      sx={{
        py: { xs: 6, md: 10 },
        backgroundColor: 'white',
      }}
    >
      <Container maxWidth='lg'>
        {/* Section Header */}
        <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
          <Typography
            variant='h2'
            component='h2'
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: { xs: '28px', md: '36px' },
              lineHeight: 1.53,
              color: '#001A44',
              mb: 3,
              textTransform: 'uppercase',
            }}
          >
            {data.title}
          </Typography>

          {data.subtitle && (
            <Typography
              variant='body1'
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: 1.75,
                color: '#414653',
                maxWidth: '400px',
                mx: 'auto',
                mb: 4,
              }}
            >
              {data.subtitle}
            </Typography>
          )}
        </Box>

        {/* Features Grid */}
        <Grid container spacing={3} rowSpacing={6} justifyContent='center'>
          {data.items && data.items.length > 0 ? (
            data.items.map((item, _index) => (
              <Grid key={item.id} size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  {/* Icon */}
                  <Box
                    sx={{
                      width: 82,
                      height: 82,
                      borderRadius: '50%',
                      mr: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                      flexShrink: 0,
                    }}
                  >
                    {item.icon && item.icon.url && (
                      <Box
                        component='img'
                        src={getImageUrl(item.icon)}
                        alt={item.icon.alternativeText || item.icon.name}
                        sx={{
                          width: 60,
                          height: 60,
                          objectFit: 'contain',
                        }}
                      />
                    )}
                  </Box>

                  <Box>
                    {/* Title */}
                    <Typography
                      variant='h6'
                      component='h3'
                      sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 700,
                        fontSize: '18px',
                        lineHeight: 1.56,
                        color: '#0F2137',
                        mb: 2,
                      }}
                    >
                      {item.title}
                    </Typography>

                    {/* Description */}
                    <Typography
                      variant='body2'
                      sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 400,
                        fontSize: '16px',
                        lineHeight: 1.75,
                        color: '#343D48',
                        flex: 1,
                      }}
                    >
                      {item.description}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))
          ) : (
            <Grid size={{ xs: 12 }}>
              <Typography
                variant='body1'
                sx={{
                  textAlign: 'center',
                  color: '#6c757d',
                  fontStyle: 'italic',
                }}
              >
                Không có dữ liệu hiển thị
              </Typography>
            </Grid>
          )}
        </Grid>
      </Container>
    </Box>
  );
}
